import Swiper from "swiper";
import sptk from "../../libs/sptk";

class CarouselsModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        //ES6 rebind

        this.bindUI();
        this.setInitialProps();
        this.initCarousels();
    }

    bindUI() {
        this.ui = {};

        this.ui.$carouselImplantations = document.querySelectorAll(
            ".js-carousel-implantations"
        );
        this.ui.$carouselPublications = document.querySelectorAll(
            ".js-carousel-publications"
        );
        this.ui.$carouselVertical = document.querySelectorAll(
            ".js-carousel-vertical"
        );
        this.ui.$carouselMetiers = document.querySelectorAll(
            ".js-carousel-metiers"
        );
        this.ui.$carouselCentrales = document.querySelectorAll(
            ".js-carousel-centrales"
        );
        this.ui.$carouselPortraits = document.querySelectorAll(
            ".js-carousel-portraits"
        );
        this.ui.$carouselTrombi = document.querySelectorAll(
            ".js-carousel-trombi"
        );
        this.ui.$carouselLR = document.querySelectorAll(".js-carousel-lr");

        this.ui.$carouselFundationNews = document.querySelectorAll(
            ".js-carousel-fundation-news"
        );
        this.ui.$carouselFundationProjects = document.querySelectorAll(
            ".js-carousel-fundation-projects"
        );
        this.ui.$carouselFundationBoard = document.querySelectorAll(
            ".js-carousel-fundation-board"
        );
         this.ui.$carouselRemonteePage = document.querySelectorAll(
            ".js-carousel-remontee-page"
        );
         this.ui.$carouselTemoignagesCareers = document.querySelectorAll(
            ".js-carousel-temoignages"
        );

        window.addEventListener("resize", this.onResize.bind(this));
    }

    setInitialProps() {
        this.sizes = {};
        this.sizes = {
            tablet: 1024,
        };
    }

    initCarousels() {
        this.carousels = [];

        if (this.ui.$carouselImplantations.length) {
            [].forEach.call(
                this.ui.$carouselImplantations,
                ($carousel, index) => {
                    this.initCarouselsImplantations($carousel, index);
                }
            );
        }

        if (this.ui.$carouselPublications.length) {
            [].forEach.call(
                this.ui.$carouselPublications,
                ($carousel, index) => {
                    this.initCarouselsPublications($carousel, index);
                }
            );
        }

        if (this.ui.$carouselVertical.length) {
            [].forEach.call(this.ui.$carouselVertical, ($carousel, index) => {
                this.initCarouselsVertical($carousel, index);
            });
        }

        if (this.ui.$carouselMetiers.length) {
            [].forEach.call(this.ui.$carouselMetiers, ($carousel, index) => {
                this.initCarouselsMetiers($carousel, index);
            });
        }

        if (this.ui.$carouselCentrales.length) {
            [].forEach.call(this.ui.$carouselCentrales, ($carousel, index) => {
                this.initCarouselsCentrales($carousel, index);
            });
        }

        if (this.ui.$carouselPortraits.length) {
            [].forEach.call(this.ui.$carouselPortraits, ($carousel, index) => {
                this.initCarouselsPortraits($carousel, index);
            });
        }

        if (this.ui.$carouselLR.length) {
            [].forEach.call(this.ui.$carouselLR, ($carousel, index) => {
                this.initCarouselsLR($carousel, index);
            });
        }

        if (this.ui.$carouselTrombi.length) {
            this.ui.$carouselBoxTrombi = document.querySelectorAll(
                ".js-carousel-box-trombi"
            );
            [].forEach.call(this.ui.$carouselTrombi, ($carousel, index) => {
                this.initCarouselsTrombi($carousel, index);
            });

            if (this.ui.$carouselBoxTrombi.length) {
                [].forEach.call(
                    this.ui.$carouselBoxTrombi,
                    ($carouselBoxTrombi, index) => {
                        $carouselBoxTrombi.addEventListener(
                            "click",
                            this.onCarouselBoxTrombiClick.bind(this)
                        );
                    }
                );
            }
        }

        if (this.ui.$carouselFundationNews.length) {
            this.ui.$carouselBoxFundationNews = document.querySelectorAll(
                ".js-carousel-fundation-projects"
            );
            [].forEach.call(
                this.ui.$carouselFundationNews,
                ($carousel, index) => {
                    this.initCarouselFundationNews($carousel, index);
                }
            );
        }

        if (this.ui.$carouselFundationProjects.length) {
            this.ui.$carouselFundationProjects = document.querySelectorAll(
                ".js-carousel-fundation-projects"
            );
            [].forEach.call(
                this.ui.$carouselFundationProjects,
                ($carousel, index) => {
                    this.initcarouselFundationProjects($carousel, index);
                }
            );
        }

        if (this.ui.$carouselFundationBoard.length) {
            this.ui.$carouselFundationBoard = document.querySelectorAll(
                ".js-carousel-fundation-board"
            );
            [].forEach.call(
                this.ui.$carouselFundationBoard,
                ($carousel, index) => {
                    this.initcarouselFundationBoard($carousel, index);
                }
            );
        }

        if (this.ui.$carouselRemonteePage.length) {
            [].forEach.call(
                this.ui.$carouselRemonteePage,
                ($carousel, index) => {
                    this.initCarouselsRemonteePage($carousel, index);
                }
            );
        }

          if (this.ui.$carouselTemoignagesCareers.length) {
            this.ui.$carouselTemoignagesCareers = document.querySelectorAll(
                ".js-carousel-temoignages"
            );
            [].forEach.call(
                this.ui.$carouselTemoignagesCareers,
                ($carousel, index) => {
                    this.initcarouselTemoignagesCareers($carousel, index);
                }
            );
        }
    }

    initCarouselsImplantations($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            allowTouchMove: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();
        currentCarousel.name = "carousel-implantations";

        this.carousels.push(currentCarousel);
    }

    initCarouselsPublications($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 3,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                767: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        this.carousels.push(currentCarousel);
    }

    initCarouselsLR($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    spaceBetween: 15,
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        this.carousels.push(currentCarousel);
    }

    initCarouselsVertical($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "vertical",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: true,
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            pagination: {
                el: ".js-carousel-pager",
                type: "bullets",
                renderBullet: function (index, className) {
                    return (
                        '<span class="' +
                        className +
                        '">' +
                        (index + 1) +
                        "</span>"
                    );
                },
                clickable: true,
                bulletClass: "carousel__pagination__item",
                bulletActiveClass: "is-active",
            },
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    direction: "horizontal",
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 200);

        setTimeout(() => {
            currentCarousel.updateAutoHeight(0);
            currentCarousel.updateSize();
            currentCarousel.update();

            const fullyUpdatedEvent = new CustomEvent("carousel:fullyRdy");

            setTimeout(() => {
                document.body.dispatchEvent(fullyUpdatedEvent);
            }, 100);
        }, 500);

        currentCarousel.name = "carousel-vertical";

        this.carousels.push(currentCarousel);
    }

    initCarouselsMetiers($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            centeredSlides: true,
            init: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        this.carousels.push(currentCarousel);
    }

    initCarouselsCentrales($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        this.carousels.push(currentCarousel);
    }

    initCarouselsPortraits($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            init: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    spaceBetween: 30,
                },
                767: {
                    spaceBetween: 15,
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();

        this.carousels.push(currentCarousel);
    }

    initCarouselsTrombi($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            direction: "horizontal",
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass: "is-active",
            slideVisibleClass: "is-visible",
            autoHeight: false,
            speed: 500,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: false,
            setWrapperSize: true,
            centeredSlides: true,
            init: false,
            allowTouchMove: false,
            navigation: {
                nextEl: ".js-carousel-next",
                prevEl: ".js-carousel-prev",
                disabledClass: "is-disabled",
                hiddenClass: "is-invisible",
            },
            breakpoints: {
                1024: {
                    spaceBetween: 30,
                    allowTouchMove: true,
                },
            },
            on: {
                init: () => {
                    const updateEvent = new CustomEvent("carousel:rdy");

                    setTimeout(() => {
                        document.body.dispatchEvent(updateEvent);
                    }, 100);
                },
            },
        });

        currentCarousel.init();
        currentCarousel.name = "carousel-trombi";

        this.carousels.push(currentCarousel);
    }

    initCarouselFundationNews($carousel, index) {
        const currentCarousel = new Swiper($carousel.querySelector('.carousel'), {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: $carousel.querySelector('.js-carousel-next'),
                prevEl: $carousel.querySelector('.js-carousel-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                },
            },
        });

        currentCarousel.init();

        if (window.innerWidth >= 1024) {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 3;
        } else {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 1;
        }

        this.carousels.push(currentCarousel);
    }

    initcarouselFundationProjects($carousel, index) {
        const currentCarousel = new Swiper($carousel.querySelector('.carousel'), {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: $carousel.querySelector('.js-carousel-next'),
                prevEl: $carousel.querySelector('.js-carousel-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                },
            },
        });

        currentCarousel.init();

        if (window.innerWidth >= 1024) {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 3;
        } else {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 1;
        }

        this.carousels.push(currentCarousel);
    }

    initcarouselFundationBoard($carousel, index) {
        const currentCarousel = new Swiper($carousel, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            init: window.innerWidth <= 768,
            allowTouchMove: true,
        });

        this.carousels.push(currentCarousel);
    }

    onCarouselBoxTrombiClick(e) {
        const target = e.currentTarget.getAttribute("data-index") * 1;
        if (this.carousels.length) {
            this.carousels.forEach((carousel) => {
                if (carousel.name && carousel.name == "carousel-trombi") {
                    carousel.slideTo(target, 0);
                }
            });
        }
    }

    onResize() {
        this.carousels.forEach((carousel) => {
            if (carousel.name && carousel.name == "carousel-vertical") {
                carousel.updateAutoHeight(0);

                if (window.innerWidth > this.sizes.tablet) {
                    carousel.wrapperEl.style.width = "auto";
                } else {
                    carousel.wrapperEl.style.height = "auto";
                }
            }
        });
    }

    initCarouselsRemonteePage($carousel, index) {
    const counterEl = $carousel.querySelector('.js-carousel-counter');
    const prevBtn = $carousel.querySelector('.js-carousel-prev');
    const nextBtn = $carousel.querySelector('.js-carousel-next');

    const currentCarousel = new Swiper($carousel.querySelector('.carousel'), {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
            disabledClass: "is-disabled",
            hiddenClass: "is-invisible",
        },
        on: {
    init: function() {
        const swiper = this;
        const currentEl = $carousel.querySelector('.swiper-counter__current');

        function padZero(num) {
            return num.toString().padStart(2, '0');
        }
        // compteur initial
        if (currentEl) currentEl.textContent = padZero(swiper.activeIndex + 1);

        // première slide : désactiver flèche gauche
        prevBtn.classList.add('is-disabled');

        document.body.dispatchEvent(new CustomEvent("carousel:rdy"));
    },
    slideChange: function() {
        const swiper = this;
        const currentEl = $carousel.querySelector('.swiper-counter__current');

        function padZero(num) {
            return num.toString().padStart(2, '0');
        }

        // compteur dynamique
        if (currentEl) currentEl.textContent = padZero(swiper.activeIndex + 1);

        // gérer désactivation flèche gauche / droite
        if (swiper.activeIndex === 0) {
            prevBtn.classList.add('is-disabled');
        } else {
            prevBtn.classList.remove('is-disabled');
        }

        if (swiper.activeIndex === swiper.slides.length - 1) {
            nextBtn.classList.add('is-disabled');
        } else {
            nextBtn.classList.remove('is-disabled');
        }
    }
},

    });

    currentCarousel.init();
    this.carousels.push(currentCarousel);
}

 initcarouselTemoignagesCareers($carousel, index) {
        const currentCarousel = new Swiper($carousel.querySelector('.carousel'), {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: $carousel.querySelector('.js-carousel-next'),
                prevEl: $carousel.querySelector('.js-carousel-prev'),
            },
            breakpoints: {
                1024: {
                    slidesPerView: 'auto',
                },
            },
        });

        currentCarousel.init();

        if (window.innerWidth >= 1024) {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 3;
        } else {
            currentCarousel.allowTouchMove = currentCarousel.slides.length > 1;
        }

        this.carousels.push(currentCarousel);
    }


}

export default CarouselsModule;
